<template>
  <shipment-plan/>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import ShipmentPlan from '@/components/shipment-plan/ShipmentPlan';

export default {
  mixins: [BaseView],
  created() { this.updateTitle('発送'); },
};

Vue.component('shipment-plan', ShipmentPlan);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
